import { lazy } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';

const Home = lazy(() => import('../pages/home/page'));
const Login = lazy(() => import('../pages/login/page'));
const Onboarding = lazy(() => import('../pages/onboarding/page'));
const Servicos = lazy(() => import('../pages/servicos/page'));
const Pagamento = lazy(() => import('../pages/pagamento/page'));
const Confirmacao = lazy(() => import('../pages/confirmacao/page'));
const Dashboard = lazy(() => import('../pages/dashboard/page'));
const Faturas = lazy(() => import('../pages/faturas/page'));
const Perfil = lazy(() => import('../pages/perfil/page'));
const Editor = lazy(() => import('../pages/editor/page'));
const Sale = lazy(() => import('../pages/sale/page'));

const MasterDashboard = lazy(() => import('../pages/master/dashboard/page'));
const MasterClients = lazy(() => import('../pages/master/clients/page'));
const MasterNewClient = lazy(() => import('../pages/master/clients/new/page'));
const MasterServices = lazy(() => import('../pages/master/services/page'));

const NotFound = lazy(() => import('../pages/NotFound'));

function HomeRedirect() {
  const token = localStorage.getItem('token');
  const userRaw = localStorage.getItem('user');

  if (!token || !userRaw) {
    return <Home />;
  }

  try {
    const user = JSON.parse(userRaw);

    if (user?.is_master) {
      return <Navigate to="/master/dashboard" replace />;
    }

    if (user?.role === 'client') {
      const subscriptionActive = !!user?.site?.subscription_active;

      if (!subscriptionActive) {
        return <Navigate to="/onboarding" replace />;
      }

      return <Navigate to="/dashboard" replace />;
    }
  } catch {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  }

  return <Home />;
}

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomeRedirect />,
  },

  {
    path: '/sale',
    element: <Sale />,
  },

  {
    path: '/login',
    element: <Login />,
  },

  {
    element: <ProtectedRoute allowedRoles={['master']} />,
    children: [
      {
        path: '/master',
        element: <Navigate to="/master/dashboard" replace />,
      },
      {
        path: '/master/dashboard',
        element: <MasterDashboard />,
      },
      {
        path: '/master/clients',
        element: <MasterClients />,
      },
      {
        path: '/master/clients/new',
        element: <MasterNewClient />,
      },
      {
        path: '/master/services',
        element: <MasterServices />,
      },
    ],
  },

  {
    element: <ProtectedRoute allowedRoles={['client']} />,
    children: [
      {
        path: '/onboarding',
        element: <Onboarding />,
      },
      {
        path: '/servicos',
        element: <Servicos />,
      },
      {
        path: '/pagamento',
        element: <Pagamento />,
      },
      {
        path: '/confirmacao',
        element: <Confirmacao />,
      },
      {
        path: '/dashboard',
        element: <Dashboard />,
      },
      {
        path: '/faturas',
        element: <Faturas />,
      },
      {
        path: '/editor',
        element: <Editor />,
      },
    ],
  },

  {
    element: <ProtectedRoute allowedRoles={['client', 'master']} />,
    children: [
      {
        path: '/perfil',
        element: <Perfil />,
      },
    ],
  },

  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;